import React, { useState } from 'react';
import * as Constants from './constants';
import { getMonthNumber } from './utils';
import { MapFilter } from './MapFilter';
import { WinLossMap } from './WinLossMap';

export const WinLossMapContainer = ({
    sections,
    sectionNumber,
    rawData,
    isLoading,
    productTypeName,
    handleProductTypeChanged,
    handleSectionChanged,
}) => {
    const years = rawData && rawData.length > 0
        ? Array.from(
            new Set(rawData.map(d => d.year))
        ).sort()
        : [new Date().getFullYear()];
    const [year, setYear] = useState(years[years.length - 1]);
    const selectedYear = years.includes(year) ? year : years[years.length - 1];
    const [startMonth, setStartMonth] = useState(1);
    const [endMonth, setEndMonth] = useState(12);
    const [mapType, setMapType] = useState(Constants.MAP_TYPE_US_REGIONS);

    if (isLoading) {
        return <p>Loading manufacturer data...</p>
    }

    if (!sections || sections.length === 0) {
        return "Please select a manufacturer with Enhanced Listing sections.";
    }

    const productTypeSet = new Set(rawData ? rawData.map(d => d.productTypeName) : []);
    const productTypes = rawData
        ? Array.from(productTypeSet)
        : [];
    productTypes.unshift(Constants.ALL_PRODUCT_TYPES);
    const productType = productTypeName && productTypeSet.has(productTypeName)
        ? productTypeName
        : productTypes[0];
    return (
        <div>
            <MapFilter
                sections={sections}
                sectionNumber={sectionNumber}
                handleSectionChanged={handleSectionChanged}
                handleYearChanged={setYear}
                startMonth={startMonth}
                handleStartMonthChanged={(monthName) => setStartMonth(getMonthNumber(monthName))}
                endMonth={endMonth}
                handleEndMonthChanged={(monthName) => setEndMonth(getMonthNumber(monthName))}
                selectedMapType={mapType}
                handleMapTypeChanged={setMapType}
                years={years}
                year={selectedYear}
                productTypes={productTypes}
                productType={productType}
                handleProductTypeChanged={handleProductTypeChanged}
            />
            <div style={{ marginTop: 10 }} >
                <WinLossMap
                    mapType={mapType}
                    rawData={rawData}
                    sectionNumber={sectionNumber}
                    year={selectedYear}
                    startMonth={startMonth}
                    endMonth={endMonth}
                    productType={productType}
                />
            </div>
        </div>
    )
}
